var _excluded = ["image", "size", "openLightBoxText", "closeLightBoxText", "hasLightbox", "backgroundColor"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import useBreakpoint from "../../../hooks/useBreakpoint";
import Picture from "../../quarks/Picture";
import { StyledLogoBoxAtm, ZoomLightBox } from "./LogoBoxAtm.styled";
export var sizes = {
  small: {
    boxSizeSpace: 10,
    logoSizeSpace: 5,
    shadowSize: "small"
  },
  medium: {
    boxSizeSpace: 15,
    logoSizeSpace: 7,
    shadowSize: "small"
  },
  large: {
    boxSizeSpace: 19,
    logoSizeSpace: 9,
    shadowSize: "large"
  },
  huge: {
    boxSizeSpace: 22.5,
    logoSizeSpace: 20.5,
    shadowSize: "large",
    medium: {
      boxSizeSpace: 28,
      logoSizeSpace: 26
    }
  }
};
export { sizes as logoBoxAtmSizes };
export var defaultProps = {
  backgroundColor: "backgroundLight"
};
function LogoBoxAtm(_ref) {
  var image = _ref.image,
    size = _ref.size,
    openLightBoxText = _ref.openLightBoxText,
    closeLightBoxText = _ref.closeLightBoxText,
    hasLightbox = _ref.hasLightbox,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? defaultProps.backgroundColor : _ref$backgroundColor,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  var imageWrapperJsx = hasLightbox ? /*#__PURE__*/React.createElement(Zoom, {
    a11yNameButtonUnzoom: openLightBoxText,
    a11yNameButtonZoom: closeLightBoxText,
    zoomMargin: !isSmallOnly ? 310 : undefined
  }, /*#__PURE__*/React.createElement(Picture, {
    srcData: image
  })) : /*#__PURE__*/React.createElement(Picture, {
    srcData: image
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasLightbox ? /*#__PURE__*/React.createElement(ZoomLightBox, null) : null, /*#__PURE__*/React.createElement(StyledLogoBoxAtm, _extends({
    $size: size,
    $backgroundColor: backgroundColor
  }, restProps), imageWrapperJsx));
}
export default LogoBoxAtm;